import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cancel-account',
  templateUrl: './cancel-account.component.html'
})
export class CancelAccountComponent implements OnInit {

  constructor( private router: Router) { }

  ngOnInit(): void {
  }

  redirectToLogin(){
    this.router.navigate(['/employer/login']);
  }

}
